export default {"src":"/_next/static/media/related.fa66af4d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};